import { returnTogglableDefaultBusinessPermissions } from './returnTogglableDefaultBusinessPermissions.util';

export const returnEffectiveUserBusinessPermissions = (
  usersBusinessPermissions,
  allRoles,
  resource,
  selectedProject
) => {
  const foundUserBusinessPermissionItem = usersBusinessPermissions.find(
    (userBusinessPermissions) =>
      userBusinessPermissions.userId === resource.user &&
      userBusinessPermissions.businessId === selectedProject.business_id
  );

  const foundUserBusinessPermissions =
    foundUserBusinessPermissionItem?.permissions;

  let roleBusinessPermissions;

  const appDefaultBusinessPermissions =
    returnTogglableDefaultBusinessPermissions();

  if (
    foundUserBusinessPermissionItem &&
    foundUserBusinessPermissionItem.roleId
  ) {
    const projectRoles = allRoles.filter(
      (role) => role.projectId === selectedProject.id
    );

    const userRole = projectRoles.find(
      (role) => role.roleId === foundUserBusinessPermissionItem.roleId
    );

    const rolePermissions = userRole?.permissions;

    const employerPermissionsOfRole = rolePermissions
      ? Object.keys(rolePermissions).filter((userRoleKey) =>
          Object.keys(appDefaultBusinessPermissions).includes(userRoleKey)
        )
      : [];

    let roleBusinessPermissionDefinitions = {};

    employerPermissionsOfRole.forEach((employerPermission) => {
      roleBusinessPermissionDefinitions[employerPermission] =
        rolePermissions[employerPermission];
    });

    roleBusinessPermissions = {
      ...appDefaultBusinessPermissions,
      ...roleBusinessPermissionDefinitions,
    };
  }

  const effectiveBusinessPermissions = {
    ...roleBusinessPermissions,
    ...foundUserBusinessPermissions,
  };

  return effectiveBusinessPermissions;
};
